import React from 'react';
import { ChipCheckbox } from '../../../../../base/components/Forms/ChipCheckbox';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { vacancyFormActions } from '../../redux/slices/vacancyFormSlice';

export const ConditionsChips = () => {
    const dispatch = useAppDispatch();
    const {
        fields: {
            isAccomodationProvided,
            isClothesProvided,
            isFoodProvided,
            isTransferProvided,
            isSeasonalWork,
            isRemoteWork,
        },
    } = useAppSelector((state) => state.vacancyForm);

    const changeHandler = (checked: boolean, id: string) => {
        if (checked) {
            const fieldNames = ['isAccomodationProvided', 'isFoodProvided', 'isClothesProvided', 'isTransferProvided'];
            if (id === 'isRemoteWork') {
                if (checked) {
                    fieldNames.map((fieldName) =>
                        dispatch(vacancyFormActions.setField({ id: fieldName, value: false })),
                    );
                }
            }
            if (fieldNames.includes(id)) {
                dispatch(vacancyFormActions.setField({ id: 'isRemoteWork', value: false }));
            }
        }

        dispatch(vacancyFormActions.setField({ id, value: checked }));
    };

    return (
        <>
            <ChipCheckbox
                icon='bed-light'
                text={__t('Жилье')}
                id='isAccomodationProvided'
                checked={isAccomodationProvided}
                onChange={changeHandler}
            />
            <ChipCheckbox
                icon='plate-utensils-light'
                text={__t('Питание')}
                id='isFoodProvided'
                checked={isFoodProvided}
                onChange={changeHandler}
            />
            <ChipCheckbox
                icon='shirt-light'
                text={__t('Рабочая одежда')}
                id='isClothesProvided'
                checked={isClothesProvided}
                onChange={changeHandler}
            />
            <ChipCheckbox
                icon='car-bus-light'
                text={__t('Трансфер до рабочего места')}
                id='isTransferProvided'
                checked={isTransferProvided}
                onChange={changeHandler}
            />
            <ChipCheckbox
                icon='sun-bright-light'
                text={__t('Сезонная работа')}
                id='isSeasonalWork'
                checked={isSeasonalWork}
                onChange={changeHandler}
            />
            <ChipCheckbox
                icon='house-laptop-light'
                text={__t('Удаленная работа')}
                id='isRemoteWork'
                checked={isRemoteWork}
                onChange={changeHandler}
            />
        </>
    );
};
